import ChannelSwitchDropdown from './ChannelSwitchDropdown';
import { useAllowedMessageChannelIds } from '../../../reply-editor/protected/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
function getSelectedEditorKey({
  allowedMessageChannelIds,
  originalGenericChannelId
}) {
  if (!allowedMessageChannelIds) {
    return null;
  }
  if (allowedMessageChannelIds.includes(originalGenericChannelId)) {
    return originalGenericChannelId;
  }
  return allowedMessageChannelIds[0];
}
export const ChannelTabs = ({
  associatedObjectId,
  associatedObjectTypeId,
  callingSource,
  currentChannelId,
  disableCalling,
  isKnownVisitor,
  onSelectedChange,
  originalGenericChannelId,
  subjectId,
  inboxId,
  threadId
}) => {
  const {
    allowedMessageChannelIds
  } = useAllowedMessageChannelIds({
    originalGenericChannelId
  });
  const selectedEditorKey = getSelectedEditorKey({
    allowedMessageChannelIds,
    originalGenericChannelId
  });
  if (!selectedEditorKey || !allowedMessageChannelIds || allowedMessageChannelIds.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ChannelSwitchDropdown, {
    allowedMessageChannelIds: allowedMessageChannelIds,
    currentChannelId: currentChannelId,
    defaultChannelId: selectedEditorKey,
    associatedObjectId: associatedObjectId,
    associatedObjectTypeId: associatedObjectTypeId,
    callingSource: callingSource,
    hasCalling: !disableCalling,
    isKnownVisitor: isKnownVisitor,
    onSelectedChange: onSelectedChange,
    subjectId: subjectId,
    inboxId: inboxId,
    threadId: threadId
  });
};
ChannelTabs.displayName = 'ChannelTabs';